import angular from "angular";

angular
	.module('app')
	.component('dfApplicationAcceptShow', {
		template: require('./df-application-accept-show.html'),
        controller: ['$http', '$uibModal', controller],
        bindings: {
            application: '<',
            user: '<'
        }
    });
    
function controller($http, $uibModal) {

    let $ctrl = this;

    $ctrl.loading = false;

    $ctrl.$onInit = function () {
    };

    $ctrl.showAppCar = function (carIndex) {
        $ctrl.application.app_cars[carIndex].show = !$ctrl.application.app_cars[carIndex].show;
    }

    $ctrl.changeDisable = (carIndex, categoryKey, index) => {
        let url = '/df/applications/' + $ctrl.application.id + '/change-disable';
        let params = {
            mode: categoryKey ? 'detail' : 'other',
            item_id: categoryKey ? $ctrl.application.app_cars[carIndex].categories[categoryKey][index].id : $ctrl.application.app_cars[carIndex].app_others[index].id,
        };

        $http.post(url, params);
    }

    $ctrl.openSetUserModal = () => {
        $uibModal.open({
            component: 'dfSetUserModal',
            size: 'lg',
            resolve: {
                applicationId: function () {
                    return $ctrl.application.id;
                }
            }
        }).result.then((res) => {
            $ctrl.application.word_path = res.word_path;
            window.open('/df/applications/'+ $ctrl.application.id + '/download-word-document');
        });
    }
}